import { useAeropayUser } from '@iheartjane/data-access/react-query';
import { useEffect, useState } from 'react';

import { PROMPTS, usePrompt } from '@jane/shared-ecomm/hooks';
import { getJwt } from '@jane/shared/auth';
import { useShouldShowGold } from '@jane/shared/hooks';
/* eslint-disable-next-line no-restricted-imports */
import type { Store } from '@jane/shared/models';

import { BankLinkingModal } from '../bankLinkingModal/bankLinkingModal';

// 14 days
const DISMISS_MILLISECONDS = 24 * 14 * 60 * 60 * 1000;

export const BankLinkingModalWithPrompt = ({
  customerId,
  onRequestClose,
  store,
}: {
  customerId: string | number | null;
  onRequestClose?: () => void;
  store: Store | null;
}) => {
  const [showLinkBankModal, setShowLinkBankModal] = useState(false);

  const { data: aeropayUser, isPending: isLoadingAeropayUser = true } =
    useAeropayUser({
      janeUserId: customerId,
      jwt: getJwt(),
    });
  const isJaneGoldMember =
    !!aeropayUser && aeropayUser.bank_accounts.length > 0;

  const janeGold = useShouldShowGold({ store: store as Store });

  const [showPrompt, dismissPrompt] = usePrompt({
    prompt: PROMPTS.linkBank,
    dismissible: true,
    dismissTime: DISMISS_MILLISECONDS,
  });

  const hideJanePayBranding = store
    ? Boolean(store?.jane_pay_integration?.white_label) ||
      Boolean(!store?.jane_pay_integration?.enabled)
    : false;

  const isNotJaneGoldMember = !isJaneGoldMember && janeGold && showPrompt;

  // Note: the JaneGoldPrompt should only be shown to users immediately after they have signed in (and if they meet the criteria)
  useEffect(() => {
    if (!!customerId && !isLoadingAeropayUser && isNotJaneGoldMember) {
      setShowLinkBankModal(true);
    }
  }, [customerId, isLoadingAeropayUser]);

  if (isLoadingAeropayUser) {
    return <div data-testid="loading" />;
  }

  if (!showLinkBankModal) {
    return null;
  }

  return (
    <BankLinkingModal
      hideJanePayBranding={hideJanePayBranding}
      showPrompt
      open={showLinkBankModal}
      onRequestClose={() => {
        onRequestClose && onRequestClose();
        dismissPrompt();

        setShowLinkBankModal(false);
      }}
      location="header"
      storePhoto={store?.photo || undefined}
      isGold={janeGold}
    />
  );
};
